// Copyright (c) 2026 Goffy. This file belongs to Goffy. All Rights Reserved.

import { Image, View as NativeView } from 'react-native';

import { Text } from '@/components/Themed';

import { GolfballIcon } from './assets';
import type { StyleSheet as StyleSheetType } from 'react-native';

const defaultStyles = {
  puttBallRow: { flexDirection: 'row', alignItems: 'center' },
  puttBallIcon: { width: 18, height: 18, marginRight: 2 },
  puttText: { fontSize: 12, color: '#f8fafc' },
} satisfies Record<string, object>;

const coalesceStyle = <T,>(style: T | undefined, fallback: T) => style ?? fallback;

export const renderPuttBalls = (
  count: number,
  styles?: { puttBallRow?: object; puttBallIcon?: object },
  marginRightOverride?: number,
  marginLeftOverride?: number
) => (
  <NativeView
    style={[
      coalesceStyle(styles?.puttBallRow, defaultStyles.puttBallRow),
      marginRightOverride !== undefined && { marginRight: marginRightOverride },
      marginLeftOverride !== undefined && { marginLeft: marginLeftOverride },
    ]}
  >
    {Array.from({ length: count }).map((_, index) => (
      <Image
        key={`putt-ball-${count}-${index}`}
        source={GolfballIcon}
        style={coalesceStyle(styles?.puttBallIcon, defaultStyles.puttBallIcon)}
        resizeMode="contain"
      />
    ))}
  </NativeView>
);

export const renderPuttLabel = (
  label: string,
  count: number,
  plusLabel: string,
  styles?: { puttBallRow?: object; puttBallIcon?: object; puttText?: object }
) => {
  const baseLabel = count >= 3 ? plusLabel : label;
  const sanitizedLabel = baseLabel.replace(/[0-9]+/g, '').trim();
  const marginRightOverride = count >= 3 ? 8 : undefined;
  const marginLeftOverride = count >= 3 ? 10 : undefined;
  return (
    <>
      {renderPuttBalls(count, styles, marginRightOverride, marginLeftOverride)}
      <Text style={coalesceStyle(styles?.puttText, defaultStyles.puttText)}>{sanitizedLabel || baseLabel}</Text>
    </>
  );
};
